import { environment } from '@env/environment';
import { defer, from, of } from 'rxjs';
import { map, share, switchMap, tap } from 'rxjs/operators';
var SettingsService = /** @class */ (function () {
    function SettingsService(oauthService, versionService) {
        var _this = this;
        this.oauthService = oauthService;
        this.versionService = versionService;
        this.isLightVersion$ = this.versionService.getVersion().pipe(tap(function (light) { return _this.lightVersion = light; }));
        // App Settings
        // -----------------------------------
        this.app = {
            name: "Brickclay - OAuthAdmin",
            description: "Brickclay OAuth Admin Panel",
            year: new Date().getFullYear(),
            version: environment.version,
        };
        // Layout Settings
        // -----------------------------------
        var savedLayout = localStorage.getItem("LayoutSettings");
        if (savedLayout == null)
            this.layout = {
                isFixed: true,
                isCollapsed: false,
                isBoxed: true,
                isRTL: false,
                horizontal: false,
                isFloat: false,
                asideHover: false,
                theme: null,
                asideScrollbar: false,
                isCollapsedText: false,
                useFullLayout: false,
                hiddenFooter: false,
                offsidebarOpen: false,
                asideToggled: false,
                viewAnimation: "ng-fadeInUp"
            };
        else {
            this.layout = JSON.parse(savedLayout);
            this.layout.offsidebarOpen = false;
        }
        /**
         * Defer makes promise cold
         * https://blog.angularindepth.com/observable-frompromise-cold-or-hot-531229818255
         */
        this.userProfileObservable = defer(function () { return from(_this.oauthService.loadUserProfile()); }).pipe(share());
        this.loadDiscoveryDocumentAndTryLoginObservable = defer(function () { return from(_this.oauthService.loadDiscoveryDocument()); }).pipe(share()).pipe(tap(function (a) { return _this.doc = a; })).pipe(switchMap(function (a) { return _this.oauthService.tryLogin(); })).pipe(map(function () { return _this.doc; }));
    }
    SettingsService.prototype.getUserProfile = function () {
        if (this.user == null) {
            return this.userProfileObservable;
        }
        return of(this.user);
    };
    Object.defineProperty(SettingsService.prototype, "userpicture", {
        set: function (image) {
            this.user.picture = image;
        },
        enumerable: true,
        configurable: true
    });
    SettingsService.prototype.getUserClaims = function () {
        return this.oauthService.getIdentityClaims();
    };
    SettingsService.prototype.saveLayout = function () {
        localStorage.setItem("LayoutSettings", JSON.stringify(this.layout));
    };
    SettingsService.prototype.getAppSetting = function (name) {
        return name ? this.app[name] : this.app;
    };
    SettingsService.prototype.getUserSetting = function (name) {
        return name ? this.user[name] : this.user;
    };
    SettingsService.prototype.getLayoutSetting = function (name) {
        return name ? this.layout[name] : this.layout;
    };
    SettingsService.prototype.setAppSetting = function (name, value) {
        if (typeof this.app[name] !== "undefined")
            this.app[name] = value;
    };
    SettingsService.prototype.setUserSetting = function (name, value) {
        if (typeof this.user[name] !== "undefined")
            this.user[name] = value;
    };
    SettingsService.prototype.setLayoutSetting = function (name, value) {
        if (typeof this.layout[name] !== "undefined")
            return this.layout[name] = value;
    };
    SettingsService.prototype.toggleLayoutSetting = function (name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    };
    return SettingsService;
}());
export { SettingsService };
